module.exports = __webpack_public_path__ + "img/product-kontra-bank-garansi.0e272175.jpeg";